module.exports = __webpack_public_path__ + "assets/img/206101.00df8320.svg";